import React from "react";
import { Container } from "react-bootstrap";
import { FaPlane, FaTheaterMasks, FaVolleyballBall } from "react-icons/fa";
import { GiLotusFlower } from "react-icons/gi";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";

function BeyondTech() {
  return (
    <Container fluid className="beyond-section" id="beyond-code">
      <TabWindow
        activeTabId="beyond-tech"
        activeFileName="beyond_tech.json"
        activeIcon="🎨"
        language="JSON"
        lineCount="34"
      >
        <p className="terminal-cmd section-cmd">
          <span className="terminal-dollar">$</span>
          <TypeWriter text=" whoami --beyond-code" speed={45} />
        </p>
        <h1 className="project-heading" style={{ textAlign: "center", marginBottom: "30px" }}>
          <TypeWriter text="There's More " speed={55} cursor={false} />
          <TypeWriter text="Than Code" speed={55} className="purple" tag="strong" />
        </h1>

        <p className="beyond-paragraph">
          When I'm not shipping features, you'll usually find me somewhere else entirely —
          as a <strong className="purple"><FaPlane className="beyond-inline-icon" /> traveler</strong> chasing
          new places and cultures, a trained <strong className="purple"><GiLotusFlower className="beyond-inline-icon" /> Bharatanatyam dancer</strong>,
          and a <strong className="purple"><FaVolleyballBall className="beyond-inline-icon" /> district-level throwball player</strong>.
          I also serve as the <strong className="purple"><FaTheaterMasks className="beyond-inline-icon" /> Cultural Head</strong> for
          the AI &amp; ML Department at DSCE, leading cultural initiatives on campus.
        </p>
      </TabWindow>
    </Container>
  );
}

export default BeyondTech;
